webpackJsonp([0],{

/***/ "+1ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols",
    attrs: {
      "sendEmail": _vm.sendEmail
    }
  }, [_c('b-row', {
    staticClass: "mt-5",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('h1', [_vm._v("Contact")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup1",
      "label": "Email address:",
      "label-for": "exampleInput1"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "exampleInput1",
      "type": "email",
      "required": "",
      "placeholder": "Enter email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup2",
      "label": "Your Name:",
      "label-for": "exampleInput2"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "exampleInput2",
      "type": "text",
      "required": "",
      "placeholder": "Enter name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "textLeft",
    attrs: {
      "id": "exampleInputGroup2",
      "label": "Your message:",
      "label-for": "exampleInput3"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "textarea1",
      "placeholder": "Enter message",
      "rows": 3,
      "max-rows": 6
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.form.message = $$v
      },
      expression: "form.message"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "onClick": _vm.sendEmail
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('b-jumbotron', {
    attrs: {
      "header": "Contact me",
      "lead": "You can contact with me for instance"
    }
  }, [_c('p', [_vm._v("Email: mikephotography@example.com")]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('p', [_vm._v("Phone: 608-333-666")]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "2",
        "lg": "2"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  }))], 1)], 1)], 1)], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+FAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#141414"
    }
  }, [_c('b-container', [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bg",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "noPadding"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "resp",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])
  }))], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2",
      "align-v": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("eLcy")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/",
      "title": "facebook"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Ki68")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/",
      "title": "tweeter"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Go1m")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://plus.google.com/discover",
      "title": "google plus"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("uw7Z")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://hexagon.com/news/social-media",
      "title": "hexagon"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Q09a")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://pl.pinterest.com/",
      "title": "pinterest"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("+egt")
    }
  })])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2",
      "sm": "2",
      "md": "1",
      "lg": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/features",
      "title": "snapchat"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Od+l")
    }
  })])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "12"
    }
  }, [_c('hr')])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ZJf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo14.33ac25c.png";

/***/ }),

/***/ "+aaQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+egt":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "/oiM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        email: '',
        name: '',
        message: ''
      },
      media: [{ url: 'https://www.facebook.com/', title: 'facebook', imgWhite: __webpack_require__("4VxD"), imgHover: __webpack_require__("Al8b") }, { url: 'https://twitter.com/', title: 'tweeter', imgWhite: __webpack_require__("Hi0p"), imgHover: __webpack_require__("W0Hs") }, { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: __webpack_require__("ByxW"), imgHover: __webpack_require__("dAfT") }, { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: __webpack_require__("n0PB"), imgHover: __webpack_require__("n0PB") }, { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: __webpack_require__("bAFN"), imgHover: __webpack_require__("2+9w") }, { url: 'https://github.com/features', title: 'github', imgWhite: __webpack_require__("R7EF"), imgHover: __webpack_require__("R7EF") }],
      show: true
    };
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
    },
    sendEmail: function sendEmail() {
      var url = 'http://192.168.7.5/server/mail.php';
      var data = {
        name: this.name,
        email: this.email,
        message: this.message
      };
      $.ajax({
        type: "POST",
        url: url,
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data),
        success: function success(data) {
          console.log(data);
        },
        dataType: 'json'
      });
    }
  }
});

/***/ }),

/***/ "02CG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Ah/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Jfb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo5.18a54b6.png";

/***/ }),

/***/ "0Px4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Master_vue__ = __webpack_require__("XdWn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53396090_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Master_vue__ = __webpack_require__("DG9N");
function injectStyle (ssrContext) {
  __webpack_require__("u3Nt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53396090"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Master_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53396090_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Master_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "11ya":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footerPhoto2.1b4f7a5.png";

/***/ }),

/***/ "1spm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo9.9ac7803.png";

/***/ }),

/***/ "2+9w":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "2oac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__ = __webpack_require__("dOjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc457292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__ = __webpack_require__("OCke");
function injectStyle (ssrContext) {
  __webpack_require__("sZRE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc457292"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc457292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Slider_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4VxD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4sbW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-navbar', {
    staticClass: "addBackground",
    attrs: {
      "toggleable": "lg",
      "fixed": "top",
      "type": "dark"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "nav_collapse",
      "id": "special"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("dLd/")
    }
  })])], 1), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/",
      "exact": ""
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("HOME "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/about"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("ABOUT ME "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/albums"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("ALBUMS "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/service"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("MY SERVICES "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/master"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("MASTERPIECES "), _c('div')]), _vm._v(" "), _c('b-nav-item', {
    staticClass: "navSeparator",
    attrs: {
      "to": "/contact"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_vm._v("CONTACT "), _c('div')])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6St4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship1.9105005.jpg";

/***/ }),

/***/ "72II":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__ = __webpack_require__("RgRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ image: __webpack_require__("6St4"), alt: 'alt1', desc: 'img1' }, { image: __webpack_require__("vsgi"), alt: 'alt2', desc: 'img2' }, { image: __webpack_require__("Xi3H"), alt: 'alt3', desc: 'img3' }, { image: __webpack_require__("F8xZ"), alt: 'alt4', desc: 'img4' }, { image: __webpack_require__("XxRD"), alt: 'alt5', desc: 'img5' }, { image: __webpack_require__("bnqO"), alt: 'alt6', desc: 'img6' }, { image: __webpack_require__("wJ2w"), alt: 'alt7', desc: 'img7' }, { image: __webpack_require__("Qbhm"), alt: 'alt8', desc: 'img8' }],
      list: [{ backgroundColor: '#000000', width: '100%' }, { backgroundColor: '#eee', width: '100%' }, { backgroundColor: '#f44336', width: '100%' }],
      media: [{ url: 'https://www.facebook.com/', title: 'facebook', imgWhite: __webpack_require__("4VxD"), imgHover: __webpack_require__("Al8b") }, { url: 'https://twitter.com/', title: 'tweeter', imgWhite: __webpack_require__("Hi0p"), imgHover: __webpack_require__("W0Hs") }, { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: __webpack_require__("ByxW"), imgHover: __webpack_require__("dAfT") }, { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: __webpack_require__("n0PB"), imgHover: __webpack_require__("n0PB") }, { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: __webpack_require__("bAFN"), imgHover: __webpack_require__("2+9w") }, { url: 'https://github.com/features', title: 'github', imgWhite: __webpack_require__("R7EF"), imgHover: __webpack_require__("R7EF") }],
      show: true
    };
  },

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["Slider"],
    SliderItem: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["SliderItem"]
  }
});

/***/ }),

/***/ "7jQq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.2136078.jpg";

/***/ }),

/***/ "7xUX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo7.10398a1.png";

/***/ }),

/***/ "8FcD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.6b1c80d.jpg";

/***/ }),

/***/ "Al8b":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ByxW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "CtaL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.8560391.jpg";

/***/ }),

/***/ "DG9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("MasterPieces")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center imgCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("hDw7")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "1",
        "lg": "1"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  }))], 1), _vm._v(" "), _c('b-container', {
    staticClass: "textCentred",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('ul', {
    attrs: {
      "id": "gridcontainer"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem box",
      attrs: {
        "src": item.image,
        "alt": item.alt,
        "width": item.dWidth
      }
    })])
  }))])], 1)], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DYMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('slider', {
    attrs: {
      "animation": "normal",
      "auto": true,
      "height": "900px"
    }
  }, [_c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": __webpack_require__("Wnlj"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": __webpack_require__("q1dy"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": __webpack_require__("xrQD"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('slider-item', [_c('img', {
    staticClass: "sliderImage",
    attrs: {
      "src": __webpack_require__("QF+G"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("p3IT")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Beatiful photography refueled")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center imgCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("hDw7")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "1",
        "lg": "1"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  })), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-sm-flex d-none"
  }, _vm._l((_vm.items), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "4",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "side back"
    }, [_vm._v(_vm._s(item.desc))])])])])
  })), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/Albums"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("VIEW ALL WORK")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__("QWkC")
    }
  })]), _vm._v(" "), _c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "sign text-left"
  }, [_vm._v("Best Photogrpaher For Wedding Events")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Eimpedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Master"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button leftSide"
  }, [_vm._v("READ MORE")])])], 1)], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Our philosophy")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6",
      "align-v": "center"
    }
  }, [_c('p', {
    staticClass: "sign text-left"
  }, [_vm._v("Best solution  for any event")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est,")]), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/Service"
    },
    on: {
      "click": function($event) {
        _vm.scrollTop()
      }
    }
  }, [_c('div', {
    staticClass: "button leftSide"
  }, [_vm._v("READ MORE")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "imgCentred",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "6"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": __webpack_require__("mZPa")
    }
  })])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "d-md-inline-block d-none",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('div', {
    staticClass: "embed-responsive embed-responsive-4by3"
  }, [_c('article', {
    staticClass: "embed-responsive-item"
  }, [_c('h1', {
    staticClass: "videoSign"
  }, [_vm._v("Mikes Photography"), _c('br'), _vm._v(" "), _c('span', [_vm._v("(Made by "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Mike B")]), _vm._v(", for "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ExtraVision")]), _vm._v(")")])])]), _vm._v(" "), _c('video', {
    staticClass: "embed-responsive-item",
    attrs: {
      "autoplay": "",
      "loop": "",
      "id": "video-background",
      "muted": "",
      "plays-inline": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "https://player.vimeo.com/external/158148793.hd.mp4?s=8e8741dbee251d5c35a759718d4b0976fbf38b6f&profile_id=119&oauth2_token_id=57447761",
      "type": "video/mp4"
    }
  })])])])], 1)], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DeB9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.850b4a1.jpg";

/***/ }),

/***/ "F8xZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship4.79f4899.jpg";

/***/ }),

/***/ "FTvK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footerPhoto4.cc7969d.png";

/***/ }),

/***/ "Ff8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__ = __webpack_require__("72II");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e89e43a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__ = __webpack_require__("jWJB");
function injectStyle (ssrContext) {
  __webpack_require__("LV3F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e89e43a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Albums_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e89e43a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Albums_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b646a8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("+1ju");
function injectStyle (ssrContext) {
  __webpack_require__("q5ua")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b646a8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b646a8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Go1m":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "HXo4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face4.d89aac9.png";

/***/ }),

/***/ "Hi0p":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDozZDE2NWMyOS04YmEyLTQ0YjQtODk5Mi05NDYyZDczZDJiMTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjJFNjQzMjVBMDkyMTFFNzgwMjhBQ0RBNDREN0QxNTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjJFNjQzMjRBMDkyMTFFNzgwMjhBQ0RBNDREN0QxNTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjREMDU4Njk5ODY3MTFFN0JERDJGM0Q3NTRERjM3NDAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjREMDU4NkE5ODY3MTFFN0JERDJGM0Q3NTRERjM3NDAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6GweoPAAAFSklEQVR42syZzU8rVRjG3+kX0BYopYC1zaUkaIAQw4qISvwgJi40MepKkotyo4nGuHJj4t3pH6DGnXEjN65M2BhdmJgQYWGCceEVCCUgCSKlLQUplAIdn+c4Qyq3pe200D7JCR1m5ry/8/W+7zmj6br+kIj8LeWrG+VxFAfeDWUymc+Oj4/l5ORETk9P5ezsTHK5nHrQZrOJw+EQp9MpTU1N0tLSIs3NzS9rmnYft90oayjpEvZaDJtBDQZ9+JEqA9KB8jxKFmA/7u/vy+Hh4QUE/xLKbrcrSIrQ5+fnqhFsjNkor9cr7e3tfOc5PPZTmZ3UTlgXAUo8yGdegaFvEomEpNNp6enpEY/Ho+AqERvARu7s7Kj3Ozs7Cf0abn1bDmyp+j/EM35AfpBKpaSrq0v1Si3E0dnd3VX1BQKBu5geH1uF5VwJYQh/2d7e7nC73aoXUKHUUrTP0To6OjoNBoOYSc5B/Hu5EKx6uEBhIz7FHNPX1tb0vb09/bpFG7QFmylcvlqAqSCsHWWaoNFoVMdQ6Tcl2qJN2oZuo3hKwT6ZzWZVK28SNB+YtskATeZxhW2X5kUE/3wLc1T8fr+0tbXJTYs2aZsMhqdyG7du5fcou/wLrE6dpd7K4/jS4Hsqv2fpR9+le+Kqr7fIQBYwkTGgIqJxj579BboQ+tFauycrIgNZwPQmLj9hBDVhJ9GC1xmZauXwayGykAlsb+Ny04RNMJowhDaayEQ26DGbEUV8jNdMMBpNZCIbGH8m7NNI875yuVwX2VKtRPezsrLCUKqumYFVKjKRDYzvM+3TEDFcjP1WtLi4KJFI5AEPMjc3J/Pz8+o308fe3l4ZGBiQoaGhihcw2cB4l10ZZ47JCq1oc3NTZmZmZGlp6eJ/7MmFhYWLa9a/vr4uBwcHljwN2VgHe9bG5JiJsxX19fXJ8vKyzM7Oqp4cHBxUOe7lbI4re2xszJINspGRsE3cilSaRJti9o+tCueUyk1ZCqm1tdXy3CcbGTkNzpm9W11cdNwELaVQKGQZlmyKEb93q1nx/f39Mj4+fmVjeW94eLhq70ILaVQWN3ekVsQs6art0cjIiHR0dFiu3xx5wrqwXT6y4gNN0R1NTU0VTCm5ACcmJqrqUbJxS6+8AVabxtVG51vp/okua2NjQ5DhqzievyhGR0fVFLG6eE2Z3oqwQ/BjYfoxbo0rzYzoqugN+C79K8G6u7vVXK5V+DbjADeGw3A/vyEVs4fDYWlEbW1tcV1kOGd/R88MYM8j1Syy6xKZ0LP/gPFZmzGcUQxZktlNo8nIBlvBuGQ6RxfCodfIGxtKZAIbj7c0EzaLCRyBL8sw2WgkUPpXsL3Hw8P8sOMJBALNsVhMyjj/unaRgXkGmHgZy98wUlG04A2fz6fOnuotMpAFTC/h8rvLsNTXSKKn6S+5Da6XaJsMYLmDy+9RzgrB5rDqNoLBYCKZTEo95i9t0jYYPgfLPUbb/82NQudddT6Y+wuXty5zFcvrVuCE7yAHzcbj8RuZErRBW7Cpw/Yz3DE9EN5LrPx+4zDZi02b85oPkzn0fyJheYS5S9GHSxWEvHfg0vTV1VUdPVCzYWddrJN1w8akcTZcjMOmVeBTfYjRSfSCxv0Q3Uo1H0Do8PkuRisH9/QEbv1atEeNjYJWYQBgdv0ioO8V+7TEJNmcKqybDbvi09I0HptF2SsrJbUYrfjtrIfDhs3i/TI+2sUA5kejHFg8H6ExPzBNRfmDnV12/gyDI3RvTHDMsFbJlh4lbLz/MOvjqZHx1/Q0jxpDfKi+uPz3rKUe+leAAQBUEhYc2oKvVgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Hy9b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face2.3953fdf.png";

/***/ }),

/***/ "IBDo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo12.bd10b4b.png";

/***/ }),

/***/ "Ki68":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "LR5y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo10.6ae0d2d.png";

/***/ }),

/***/ "LV3F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ldef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ image: __webpack_require__("0Jfb"), alt: 'alt1' }, { image: __webpack_require__("rzpp"), alt: 'alt2' }, { image: __webpack_require__("MnH2"), alt: 'alt3' }, { image: __webpack_require__("YPl/"), alt: 'alt4' }],
      items2: [{ image: __webpack_require__("ZvxU"), alt: 'alt5' }, { image: __webpack_require__("pfBO"), alt: 'alt6' }, { image: __webpack_require__("7xUX"), alt: 'alt7' }, { image: __webpack_require__("YaCl"), alt: 'alt8' }],
      items3: [{ image: __webpack_require__("TV5D"), alt: 'alt9' }, { image: __webpack_require__("Mn6R"), alt: 'alt10' }, { image: __webpack_require__("ihpy"), alt: 'alt11' }, { image: __webpack_require__("CtaL"), alt: 'alt12' }],
      items4: [{ image: __webpack_require__("8FcD"), alt: 'alt13' }, { image: __webpack_require__("DeB9"), alt: 'alt14' }, { image: __webpack_require__("7jQq"), alt: 'alt15' }, { image: __webpack_require__("MNtS"), alt: 'alt16' }],
      list: [{ backgroundColor: '#000000', width: '100%' }, { backgroundColor: '#eee', width: '100%' }, { backgroundColor: '#f44336', width: '100%' }],
      show: true
    };
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e98844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iGv6");
function injectStyle (ssrContext) {
  __webpack_require__("jnmJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54e98844_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MNtS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.1fb5270.jpg";

/***/ }),

/***/ "MPfG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__ = __webpack_require__("Ldef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ced1acf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__ = __webpack_require__("Prd+");
function injectStyle (ssrContext) {
  __webpack_require__("+aaQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ced1acf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Service_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ced1acf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Service_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mn6R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.fe875a2.jpg";

/***/ }),

/***/ "MnH2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo3.f3728cc.png";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_img__ = __webpack_require__("Rwp6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$', { value: __WEBPACK_IMPORTED_MODULE_5_jquery___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_img__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OCke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('slider', {
    attrs: {
      "animation": "normal",
      "auto": true,
      "interval": 5000,
      "height": "425px"
    }
  }, _vm._l((_vm.clientProp), function(item) {
    return _c('slider-item', {
      key: item.id
    }, [_c('b-container', [_c('b-row', {
      staticClass: "text-center",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('p', {
      staticClass: "sign"
    }, [_vm._v("What client say?")]), _vm._v(" "), _c('p', {
      staticClass: "separator"
    }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
      staticClass: "justify-content-md-center text-center"
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "1",
        "lg": "1",
        "align-v": "center"
      }
    }, [_c('img', {
      staticClass: "profileSize",
      attrs: {
        "src": item.image
      }
    })])], 1), _vm._v(" "), _c('b-row', {
      staticClass: "text-center",
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "align-v": "center"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "12",
        "lg": "12"
      }
    }, [_c('p', {
      staticClass: "greetingText"
    }, [_vm._v("\"" + _vm._s(item.description) + "\"")]), _vm._v(" "), _c('p', {
      staticClass: "line"
    }, [_vm._v("—")]), _vm._v(" "), _c('p', {
      staticClass: "clientDesp"
    }, [_c('span', {
      staticClass: "clientName"
    }, [_vm._v(_vm._s(item.name))]), _c('br'), _c('span', [_vm._v(_vm._s(item.profession))])])])], 1)], 1)], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Od+l":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Prd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "mt-5"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("PHOTOGRAPHY SERVICES")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("WEDDING PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items2), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("HEADSHOT PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items3), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1), _vm._v(" "), _c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('h1', [_vm._v("PORTRAIT PHOTOGRAPHY")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "text-center d-flex d-none"
  }, _vm._l((_vm.items4), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "6",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('div', {
      staticClass: "card-container"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "side"
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    })])])])])
  })), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "textLeft"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1)], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q09a":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "QF+G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider4.fee8685.jpg";

/***/ }),

/***/ "QFk4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QWkC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/flowers.cfd74a3.png";

/***/ }),

/***/ "Qbhm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship8.6463480.jpg";

/***/ }),

/***/ "R7EF":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Rwp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
!function(){if("undefined"!=typeof document){var e=document.head||document.getElementsByTagName("head")[0],t=document.createElement("style"),i=" *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { z-index: 9999; height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; display: flex; justify-content: space-between; align-items: center; } .title-v-img[data-v-5928e1c7] { font-family: 'Avenir', Helvetica, Arial, sans-serif; font-size: 18px; font-weight: 400; color: white; text-align: center; max-height: 100%; overflow: auto; } .count-v-img[data-v-5928e1c7], .close-v-img[data-v-5928e1c7] { width: 80px; font-family: 'Avenir', Helvetica, Arial, sans-serif; line-height: 50px; } .count-v-img[data-v-5928e1c7] { font-size: 15px; color: white; margin-left: 10px; } .close-v-img[data-v-5928e1c7] { margin-right: 10px; color: #E5E6EB; font-size: 30px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; text-align: right; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: 'Avenir', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ";t.type="text/css",t.styleSheet?t.styleSheet.cssText=i:t.appendChild(document.createTextNode(i)),e.appendChild(t)}}();var ImgScreen={render:function(){var e=this,t=e.$createElement,i=e._self._c||t;return i("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.closed?e._e():i("div",{staticClass:"fullscreen-v-img",on:{click:function(t){if(t.target!==t.currentTarget)return null;e.close()}}},[i("div",{staticClass:"header-v-img"},[i("span",{staticClass:"count-v-img"},[e.images.length>1?i("span",[e._v(e._s(e.currentImageIndex+1)+"/"+e._s(e.images.length)+" ")]):e._e()]),i("span",{staticClass:"title-v-img"},[e._v(e._s(e.titles[e.currentImageIndex])+" ")]),i("span",{staticClass:"close-v-img",on:{click:e.close}},[e._v("×")])]),i("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?i("span",{staticClass:"prev-v-img",on:{click:e.prev}},[i("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[i("path",{attrs:{d:"M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z",fill:"#fff"}})])]):e._e()]),i("transition",{attrs:{appear:"",name:"v-img-fade"}},[e.visibleUI&&1!==e.images.length?i("span",{staticClass:"next-v-img",on:{click:e.next}},[i("svg",{attrs:{width:"25",height:"25",viewBox:"0 0 1792 1915",xmlns:"http://www.w3.org/2000/svg"}},[i("path",{attrs:{d:"M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z",fill:"#fff"}})])]):e._e()]),i("div",{staticClass:"content-v-img"},[i("img",{attrs:{src:e.images[e.currentImageIndex]},on:{click:e.next}})])],1)])},staticRenderFns:[],_scopeId:"data-v-5928e1c7",data:function(){return{images:[],titles:[],visibleUI:!0,currentImageIndex:0,closed:!0,uiTimeout:null}},methods:{close:function(){document.querySelector("body").classList.remove("body-fs-v-img"),this.images=[],this.currentImageIndex=0,this.closed=!0},next:function(){this.currentImageIndex+1<this.images.length?this.currentImageIndex++:this.currentImageIndex=0},prev:function(){this.currentImageIndex>0?this.currentImageIndex--:this.currentImageIndex=this.images.length-1},showUI:function(){var e=this;clearTimeout(this.uiTimeout),this.visibleUI=!0,this.uiTimeout=setTimeout(function(){e.visibleUI=!1},3500)}},created:function(){var e=this;window.addEventListener("keyup",function(t){27!==t.keyCode&&81!==t.keyCode||e.close(),39!==t.keyCode&&76!==t.keyCode||e.next(),37!==t.keyCode&&72!==t.keyCode||e.prev()}),window.addEventListener("scroll",function(){e.close()}),window.addEventListener("mousemove",function(){e.showUI()})}},babelHelpers={},asyncGenerator=function(){function e(e){this.value=e}function t(t){function i(a,r){try{var o=t[a](r),s=o.value;s instanceof e?Promise.resolve(s.value).then(function(e){i("next",e)},function(e){i("throw",e)}):n(o.done?"return":"normal",o.value)}catch(e){n("throw",e)}}function n(e,t){switch(e){case"return":a.resolve({value:t,done:!0});break;case"throw":a.reject(t);break;default:a.resolve({value:t,done:!1})}(a=a.next)?i(a.key,a.arg):r=null}var a,r;this._invoke=function(e,t){return new Promise(function(n,o){var s={key:e,arg:t,resolve:n,reject:o,next:null};r?r=r.next=s:(a=r=s,i(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)},install=function(e,t){var i=e.extend(ImgScreen),n={altAsTitle:!1};t=Object.assign(n,t),e.directive("img",{bind:function(n,a){var r="pointer",o=n.src,s=a.arg||null,c=void 0;t.altAsTitle&&(c=n.alt),void 0!==a.value&&(r=a.value.cursor||r,o=a.value.src||o,s=a.value.group||s,c=a.value.title||c),n.setAttribute("data-vue-img-group",s||""),n.setAttribute("data-vue-img-src",o),n.setAttribute("data-vue-img-title",c||""),o||console.error("v-img element missing src parameter."),n.style.cursor=r;var l=window.vueImg;if(!l){var u=document.createElement("div");u.setAttribute("id","imageScreen"),document.querySelector("body").appendChild(u),l=window.vueImg=(new i).$mount("#imageScreen")}n.addEventListener("click",function(){document.querySelector("body").classList.add("body-fs-v-img");var t=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+s+'"]')));0===t.length?(e.set(l,"images",[o]),e.set(l,"titles",[c])):(e.set(l,"images",t.map(function(e){return e.dataset.vueImgSrc})),e.set(l,"titles",t.map(function(e){return e.dataset.vueImgTitle})),e.set(l,"currentImageIndex",t.indexOf(n))),e.set(l,"closed",!1)})}})};/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),

/***/ "SXQA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footerPhoto5.1760274.jpg";

/***/ }),

/***/ "TV5D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.1ccceca.jpg";

/***/ }),

/***/ "TWIh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo16.d1bf391.png";

/***/ }),

/***/ "UeRQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo6.654a269.png";

/***/ }),

/***/ "W0Hs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "W7Iq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    staticClass: "justify-content-md-center textCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align-v": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("p3IT")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("Hi my name is...")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")]), _vm._v(" "), _c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center imgCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("hDw7")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "1",
        "lg": "1"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  }))], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WHiI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo13.2e38781.png";

/***/ }),

/***/ "Wnlj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider.59b8655.png";

/***/ }),

/***/ "X+EC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/face3.8f99d8e.png";

/***/ }),

/***/ "XdWn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__ = __webpack_require__("RgRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gallerygrid__ = __webpack_require__("DoSc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gallerygrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gallerygrid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ image: __webpack_require__("6St4"), alt: 'alt1', dWidth: 320 }, { image: __webpack_require__("vsgi"), alt: 'alt2', dWidth: 420 }, { image: __webpack_require__("Xi3H"), alt: 'alt3', dWidth: 520 }, { image: __webpack_require__("F8xZ"), alt: 'alt4', dWidth: 520 }, { image: __webpack_require__("XxRD"), alt: 'alt5', dWidth: 420 }, { image: __webpack_require__("bnqO"), alt: 'alt6', dWidth: 320 }, { image: __webpack_require__("wJ2w"), alt: 'alt7', dWidth: 320 }, { image: __webpack_require__("6St4"), alt: 'alt1', dWidth: 420 }, { image: __webpack_require__("vsgi"), alt: 'alt2', dWidth: 520 }, { image: __webpack_require__("Xi3H"), alt: 'alt3', dWidth: 520 }, { image: __webpack_require__("F8xZ"), alt: 'alt4', dWidth: 420 }, { image: __webpack_require__("XxRD"), alt: 'alt5', dWidth: 320 }, { image: __webpack_require__("bnqO"), alt: 'alt6', dWidth: 320 }, { image: __webpack_require__("wJ2w"), alt: 'alt7', dWidth: 420 }, { image: __webpack_require__("XxRD"), alt: 'alt5', dWidth: 520 }, { image: __webpack_require__("bnqO"), alt: 'alt6', dWidth: 520 }, { image: __webpack_require__("wJ2w"), alt: 'alt7', dWidth: 420 }, { image: __webpack_require__("Qbhm"), alt: 'alt8', dWidth: 320 }, { image: __webpack_require__("6St4"), alt: 'alt1', dWidth: 420 }, { image: __webpack_require__("F8xZ"), alt: 'alt4', dWidth: 520 }],
      list: [{ backgroundColor: '#000000', width: '100%' }, { backgroundColor: '#eee', width: '100%' }, { backgroundColor: '#f44336', width: '100%' }],
      media: [{ url: 'https://www.facebook.com/', title: 'facebook', imgWhite: __webpack_require__("4VxD"), imgHover: __webpack_require__("Al8b") }, { url: 'https://twitter.com/', title: 'tweeter', imgWhite: __webpack_require__("Hi0p"), imgHover: __webpack_require__("W0Hs") }, { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: __webpack_require__("ByxW"), imgHover: __webpack_require__("dAfT") }, { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: __webpack_require__("n0PB"), imgHover: __webpack_require__("n0PB") }, { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: __webpack_require__("bAFN"), imgHover: __webpack_require__("2+9w") }, { url: 'https://github.com/features', title: 'github', imgWhite: __webpack_require__("R7EF"), imgHover: __webpack_require__("R7EF") }],
      show: true
    };
  },

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["Slider"],
    SliderItem: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["SliderItem"]
  }
});

/***/ }),

/***/ "Xi3H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship3.792956a.jpg";

/***/ }),

/***/ "XxRD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship5.9a61f7d.jpg";

/***/ }),

/***/ "YPl/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo4.b4a3afb.png";

/***/ }),

/***/ "YaCl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo8.5f1ea04.png";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Albums__ = __webpack_require__("Ff8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Service__ = __webpack_require__("MPfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Master__ = __webpack_require__("0Px4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Contact__ = __webpack_require__("FnhZ");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkExactActiveClass: 'active',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__components_About__["a" /* default */]
  }, {
    path: '/albums',
    name: 'Albums',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Albums__["a" /* default */]
  }, {
    path: '/service',
    name: 'Service',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Service__["a" /* default */]
  }, {
    path: '/master',
    name: 'Master',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Master__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Contact__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      media: [{ url: 'https://www.facebook.com/', title: 'facebook', imgWhite: __webpack_require__("4VxD"), imgHover: __webpack_require__("Al8b") }, { url: 'https://twitter.com/', title: 'tweeter', imgWhite: __webpack_require__("Hi0p"), imgHover: __webpack_require__("W0Hs") }, { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: __webpack_require__("ByxW"), imgHover: __webpack_require__("dAfT") }, { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: __webpack_require__("n0PB"), imgHover: __webpack_require__("n0PB") }, { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: __webpack_require__("bAFN"), imgHover: __webpack_require__("2+9w") }, { url: 'https://github.com/features', title: 'github', imgWhite: __webpack_require__("R7EF"), imgHover: __webpack_require__("R7EF") }],
      show: true
    };
  }
});

/***/ }),

/***/ "ZvxU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo1.a3a7cb3.png";

/***/ }),

/***/ "a57x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footerPhoto1.bc88227.png";

/***/ }),

/***/ "b88c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo11.981de04.png";

/***/ }),

/***/ "bAFN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "bVQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleActive: function toggleActive(event) {
      event.preventDefault();
    },
    hideMenu: function hideMenu() {
      this.$('#nav_collapse').removeClass('show');
      this.$('#nav_collapse').css({ display: 'none' });
    },
    scrollTop: function scrollTop() {
      this.$(window).scrollTop(0);
    }
  }
});

/***/ }),

/***/ "bnqO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship6.acb2b24.png";

/***/ }),

/***/ "bwGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("bVQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb6112c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("4sbW");
function injectStyle (ssrContext) {
  __webpack_require__("QFk4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcb6112c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb6112c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70996427_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("W7Iq");
function injectStyle (ssrContext) {
  __webpack_require__("02CG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70996427"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70996427_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dAfT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "dLd/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAABPCAMAAADYxwdzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjZBQzA4QzkwQUVDNDExRTc5QzcwOEMxQjYxQjBFMjkyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjZBQzA4QzkxQUVDNDExRTc5QzcwOEMxQjYxQjBFMjkyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NkFDMDhDOEVBRUM0MTFFNzlDNzA4QzFCNjFCMEUyOTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkFDMDhDOEZBRUM0MTFFNzlDNzA4QzFCNjFCMEUyOTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5sTdQCAAAAMFBMVEX+i4v9Fxf/7u79Jyf+enr/3t7/zc3+rKz+WVn+SEj+vb3+amr9ODj+m5v9Bgb////XaunMAAAAEHRSTlP///////////////////8A4CNdGQAABftJREFUeNrsWdmy4ygMFZsBG5P//9sxyIAkL0lq7q3u6rJfkhCQDkLLEYbX3/fAg+nB9GB696wqp+nvwgR5e9LXG9nWuI8xeZOVF0rlcr3kHDR+VwVT/hLSXNbYTzHVbWc9BkL5HdkcZ8aYrvPNl5iq0OVDTFNVkT01cnmYwyx52AYXxO8g4UbgQ0wxi+lJguyT1DiFyy1fPP64z2tMqIHoaANwtBMQO9rvMC1jT+8xLRLTcoap+hNQ/1u/w6Ru9wEn50z8ow8I7B6Yt+b5K0jT0R2uMYHEBBeYxmNknH6WnO5CletKEpN6h0mkAhdu9s9dHD7DNDUETcma32HCJaH9UnfxxNLT+mFtAYkpnmIqxgC2BGiIU3Ua0N8i3AIFsC24nMBkBKY5n2HShni1Je7atjRT8P2JV+VtjmRW0QwnyaljqokgSkws+uNw8QbA8szYH3UOyvJZ2TFMmMlSx+Rw1xLTQiNZteznkoS0CmXnyV5C2vZHzwQz2dIxWfwmMSUS/bq5+KzkIXup7DT63ckkEFkjT0urr4hxlZg0KXa7YjuiY/jSDhL8y8FyiQnNZKA+ChWBqKxmF9/8RumXKGgs+vewa15qJlGn0bGnwDLGMSPqLs1oisnt9miY0Ezb/8IXWPQvzO5RC6MnFlf+sgzwmARhRbdLc91ML7HHQHlGopCs1FVWgzn7W0jDvHTAhGZJ3a3wdzGPIG2M6zIzBUmQVh/ym0owImGgAm5saFlqht1cu17DXTzJYiQOJ8hwCu6uxeCGhEN9Rz3QzfTKjIB56l4iBRn9krV7t8FNZZlJ9ZgYJt9PyLGcemAjzMVbwkuG75TZT73r12DsYKKY4igY0gUMI88si6c2b86slSBVKvgPCFVHZQimKQ9jdNRKE0yeJRRH06cbFkviTOFTsreq4ZIszwQe30A9DU7Cbh6rtKE8BTHFldERdwtqz/trx4SBv9siiPIUqaswXgnkH09tO4nwL33zWWmZt4LCg2zYaaVnBSKyI00+rMUMdB7rDPeTMEUl7LwuX+SBUGudGd4DRHhgzhA5N2GeYo++1eLVyKyTJcc/of88RdFtrdQUg4FZmqBYKuCZayH5Qx/VndD0w6Q08pPLLAUZnpOB/rsQ8Y5XFCbFSX1mus3hjGyc9PyTycbLkqRObpsUbzcXVmkZgTRwmwHQSJ7WFn1Dl5vdYFSypRnUKwZ+s43i4Y8ql5umZT2ZA80U8XqdsNtzx/pgejA9mP4Appp7w7zfWbrfUvpG9umdGCABWH8L0xvZ8k7M1j7b1e/+6iL5/4KF+wtG4E2pwhVQj/HCvl/f0J9dXHx8dqZWfFcxpas7dXd3PfrZk67v6yUmjUzDVn5UuqDUbxdK9a6tbKK0u49udKeEh5mrmZd1Yy2q1HRXqM0y43mlZXRrXbbfSdNMXrcB7919vZcJ1d1VZ6OTabTWEdI4RgdZgkEeYXA2TS7/Vy7bIAHbuhZziskS4lyJnLLVd0qfFItNfOFEpbEt1J+O2vK1cDqLhLiYxFd5hUOZRhsB90tlA6qLlBvCxTspyLsCqPwRqqQVyaVtrLKNzuj2NZymypt9TnobTbo5xIpTVEFAZet2r2TP/UnlBOA7nbTVymtZFnGnaztgdL4+GtG/quuO3BNqdO3zAUl8xURk1x9QTk6fYpr4a7s9LcxFLQypdu8C6Ciye1c/bO81VHXblS6bKhoiu8oxC3+JBMzFZxKCoa3zVZBT2KBt618THlobdeh1qVok9DhHQwLmoliHQ5FHZTe2by9yAZDXS7ghXFdizULroIobFavTUVXc3mCAGfr+CEpIVNWmtAGpwqSyd881V/kpkEy2L8APmw8vMCY22gJW9RzHmik7UkHSQjaml+kKkyXuBLjbuQqpOPpVW4nn6cVHaySlciTaqIneKoWtfs6tuhs4ym5m+xX+NN3VnPX6Vag5XLj8HKZ097bTXv5pj2h/AlO9q0m3L8/jTUVffoH7zpd3OTQdx6s3nsc7gR/ApJExr/cHO19hgqdveTA9mB5MD6Z/DNN/AgwAuCR31HzITAMAAAAASUVORK5CYII="

/***/ }),

/***/ "dOjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__ = __webpack_require__("RgRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      list: [{ backgroundColor: '#000000', width: '100%' }, { backgroundColor: '#eee', width: '100%' }, { backgroundColor: '#f44336', width: '100%' }],
      clientProp: [{ image: __webpack_require__("fvfs"), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Angela Taylor', profession: 'CEO/Founder Webworldpk' }, { image: __webpack_require__("Hy9b"), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Marta Smith', profession: 'Teacher' }, { image: __webpack_require__("X+EC"), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Magda Black', profession: 'Garbage Women' }, { image: __webpack_require__("HXo4"), description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.', name: 'Elizabeth Taylor', profession: 'Blacksmith' }]
    };
  },

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["Slider"],
    SliderItem: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["SliderItem"]
  }
});

/***/ }),

/***/ "eLcy":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "fvfs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/profile2.0cb2f23.png";

/***/ }),

/***/ "hDw7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "iGv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navigation'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('slider'), _vm._v(" "), _c('myfooter')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ihpy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.41b726a.jpg";

/***/ }),

/***/ "jWJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "content"
  }, [_c('b-container', {
    staticClass: "bv-example-row bv-example-row-flex-cols"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "sign"
  }, [_vm._v("My Albums")]), _vm._v(" "), _c('p', {
    staticClass: "separator"
  }, [_vm._v("— • —")])])], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('p', {
    staticClass: "greetingText"
  }, [_vm._v("At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id")])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center imgCentred"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("hDw7")
    }
  })])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-md-center mb-5 cf"
  }, _vm._l((_vm.media), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "2",
        "sm": "2",
        "md": "1",
        "lg": "1"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "title": item.title
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgWhite
      }
    }), _c('img', {
      staticClass: "top",
      attrs: {
        "src": item.imgHover
      }
    })])])
  })), _vm._v(" "), _c('b-row', {
    staticClass: "text-center"
  }, _vm._l((_vm.items), function(item) {
    return _c('b-col', {
      key: item.id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6",
        "lg": "4",
        "xl": "3",
        "align-v": "center"
      }
    }, [_c('img', {
      directives: [{
        name: "img",
        rawName: "v-img:my-group",
        arg: "my-group"
      }],
      staticClass: "galleryItem box",
      attrs: {
        "src": item.image,
        "alt": item.alt
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.desc))])])
  }))], 1)], 1) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jmv/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footerPhoto3.ab9eed9.png";

/***/ }),

/***/ "jnmJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mZPa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photographer.a0c18e0.png";

/***/ }),

/***/ "n0PB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "oOfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ image: __webpack_require__("a57x"), alt: 'alt1' }, { image: __webpack_require__("11ya"), alt: 'alt2' }, { image: __webpack_require__("jmv/"), alt: 'alt3' }, { image: __webpack_require__("FTvK"), alt: 'alt4' }, { image: __webpack_require__("SXQA"), alt: 'alt5' }]
    };
  }
});

/***/ }),

/***/ "p3IT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/profile.ea18c05.png";

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__ = __webpack_require__("RgRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ image: __webpack_require__("ZvxU"), alt: 'alt1', desc: 'Opis 1' }, { image: __webpack_require__("rzpp"), alt: 'alt2', desc: 'Opis 2' }, { image: __webpack_require__("MnH2"), alt: 'alt3', desc: 'Opis 3' }, { image: __webpack_require__("YPl/"), alt: 'alt4', desc: 'Opis 4' }, { image: __webpack_require__("0Jfb"), alt: 'alt5', desc: 'Opis 5' }, { image: __webpack_require__("UeRQ"), alt: 'alt6', desc: 'Opis 6' }, { image: __webpack_require__("7xUX"), alt: 'alt7', desc: 'Opis 7' }, { image: __webpack_require__("YaCl"), alt: 'alt8', desc: 'Opis 8' }, { image: __webpack_require__("1spm"), alt: 'alt9', desc: 'Opis 9' }, { image: __webpack_require__("LR5y"), alt: 'alt10', desc: 'Opis 10' }, { image: __webpack_require__("b88c"), alt: 'alt11', desc: 'Opis 11' }, { image: __webpack_require__("IBDo"), alt: 'alt12', desc: 'Opis 12' }, { image: __webpack_require__("WHiI"), alt: 'alt13', desc: 'Opis 13' }, { image: __webpack_require__("+ZJf"), alt: 'alt14', desc: 'Opis 14' }, { image: __webpack_require__("t0nk"), alt: 'alt15', desc: 'Opis 15' }, { image: __webpack_require__("TWIh"), alt: 'alt16', desc: 'Opis 16' }],
      list: [{ backgroundColor: '#000000', width: '100%' }, { backgroundColor: '#eee', width: '100%' }, { backgroundColor: '#f44336', width: '100%' }],
      media: [{ url: 'https://www.facebook.com/', title: 'facebook', imgWhite: __webpack_require__("4VxD"), imgHover: __webpack_require__("Al8b") }, { url: 'https://twitter.com/', title: 'tweeter', imgWhite: __webpack_require__("Hi0p"), imgHover: __webpack_require__("W0Hs") }, { url: 'https://plus.google.com/discover', title: 'google plus', imgWhite: __webpack_require__("ByxW"), imgHover: __webpack_require__("dAfT") }, { url: 'http://hexagon.com/news/social-media', title: 'hexagon', imgWhite: __webpack_require__("n0PB"), imgHover: __webpack_require__("n0PB") }, { url: 'https://pl.pinterest.com/', title: 'pinterest', imgWhite: __webpack_require__("bAFN"), imgHover: __webpack_require__("2+9w") }, { url: 'https://github.com/features', title: 'github', imgWhite: __webpack_require__("R7EF"), imgHover: __webpack_require__("R7EF") }],
      show: true
    };
  },

  components: {
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["Slider"],
    SliderItem: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["SliderItem"]
  },
  methods: {
    scrollTop: function scrollTop() {
      this.$(window).scrollTop(0);
    }
  }
});

/***/ }),

/***/ "pa1G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pfBO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.f80c921.jpg";

/***/ }),

/***/ "q1dy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider2.a6c0713.jpg";

/***/ }),

/***/ "q5ua":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c72eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("DYMY");
function injectStyle (ssrContext) {
  __webpack_require__("pa1G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07c72eec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c72eec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rzpp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo2.2f84867.png";

/***/ }),

/***/ "sZRE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t0nk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo15.5d939f6.png";

/***/ }),

/***/ "u3Nt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uw7Z":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vsgi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship2.310eea0.jpg";

/***/ }),

/***/ "wJ2w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ship7.b105fe7.jpg";

/***/ }),

/***/ "xFsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_jquery_dist_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_jquery_dist_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_jquery_dist_jquery__);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Albums__ = __webpack_require__("Ff8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Service__ = __webpack_require__("MPfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Master__ = __webpack_require__("0Px4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Navigation__ = __webpack_require__("bwGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Slider__ = __webpack_require__("2oac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Myfooter__ = __webpack_require__("xQj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_main__ = __webpack_require__("xFsn");
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello__["a" /* default */],
    About: __WEBPACK_IMPORTED_MODULE_1__components_About__["a" /* default */],
    Albums: __WEBPACK_IMPORTED_MODULE_2__components_Albums__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_3__components_Service__["a" /* default */],
    Master: __WEBPACK_IMPORTED_MODULE_4__components_Master__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_5__components_Navigation__["a" /* default */],
    Slider: __WEBPACK_IMPORTED_MODULE_6__components_Slider__["a" /* default */],
    Myfooter: __WEBPACK_IMPORTED_MODULE_7__components_Myfooter__["a" /* default */]
  }
});

/***/ }),

/***/ "xQj9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Myfooter_vue__ = __webpack_require__("oOfO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4948859d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Myfooter_vue__ = __webpack_require__("+FAF");
function injectStyle (ssrContext) {
  __webpack_require__("0Ah/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4948859d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Myfooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4948859d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Myfooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xrQD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slider3.f58ca94.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1f80fdfd493dfbf9b6d5.js